export const trimMultipleLanguageContent = (contentToTrim) => {
  const trimmedContent = {};

  Object.entries(contentToTrim).forEach(([language, content]) => {
    trimmedContent[language] = content.trim();
  });

  return trimmedContent;
};
